import { parseHtml, twClassMerge  } from '@healthhub/react-ui';

import { OutlinedCheckmarkIcon } from '@shared/assets-icon';


export interface IStepperProps {
  steps: {
    status: 'active' | 'before-active' | 'before-active-green' | 'completed' | 'non-active';
    title: string;
  }[];
}

const Stepper = ({ steps }: IStepperProps) => {
  const getCircleStyles = (status: string) => {
    if (status === 'active') {
      return 'bg-theme-100 ring-[3px] ring-theme-100 ring-offset-4';
    }

    if (status === 'non-active' || status === 'before-active') {
      return 'bg-functional-slate';
    }

    if (status === 'before-active-green' || status === 'completed') {
      return 'bg-theme-100';
    }

    return '';
  };

  const getLineStyles = (index: number, status: string, isLeftBar: boolean) => {
    if ((index === 0 && isLeftBar) || (index === steps.length - 1 && !isLeftBar)) {
      return 'hidden';
    }

    if (
      (status === 'active' && isLeftBar) ||
      (status === 'before-active' && !isLeftBar) ||
      status === 'before-active-green' ||
      status === 'completed'
    ) {
      return 'border-theme-100';
    }

    return 'border-functional-slate';
  };

  const getCircleDisplay = (index: number, status: string) => {
    if (status === 'completed') {
      return <OutlinedCheckmarkIcon className="size-3 [&_path]:stroke-white" />;
    }

    return index + 1;
  };
  return (
    <div className={`grid-cols-${steps.length} grid justify-center text-center`}>
      {steps.map((item, index) => (
        <div className="py-4" key={item.title}>
          <div className="flex w-full items-center justify-center">
            <div className={`z-stepper size-7 rounded-full text-sm ${getCircleStyles(item.status)}`}>
              <span className="flex h-full items-center justify-center text-center text-sm font-semibold text-white">
                {getCircleDisplay(index, item.status)}
              </span>
            </div>
          </div>
          <div className="relative">
            <div
              className={`absolute bottom-[0.8125rem] right-1/2 h-px w-1/2 border-t ${getLineStyles(
                index,
                item.status,
                true
              )}`}
            />
            <div
              className={`absolute bottom-[0.8125rem] left-1/2 h-px w-1/2 border-t ${getLineStyles(
                index,
                item.status,
                false
              )}`}
            />
          </div>

          <div
            className={twClassMerge('mt-4 px-2 text-xs font-semibold wrap-break-word', {
              'text-functional-slate': item.status !== 'active' && item.status !== 'completed',
            })}
          >
            {parseHtml(item.title)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
